module.exports = {"20x20": __webpack_public_path__ + "images/satellite-debris-big-1-20x20.png"};